import React, { useContext, useState } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { RefreshCw } from 'lucide-react'
import clsx from 'clsx'
import { useHelpDrawer } from '@/context/HelpDrawerContext'
import { BreakpointContext } from '@/context'
import Button from '@/components/Button'
import Icon from '../Icon'

export const HelpDrawer: React.FC = () => {
  const { isOpen, url, title, closeHelpDrawer } = useHelpDrawer()
  const breakpoint = useContext(BreakpointContext)
  const isMobile = breakpoint.mdAndDown
  const [iframeKey, setIframeKey] = useState(0)

  const handleRefresh = () => {
    setIframeKey((prev) => prev + 1)
  }

  if (!url) return null

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={isMobile ? { y: '100%' } : { x: '100%' }}
          animate={isMobile ? { y: 0 } : { x: 0 }}
          exit={isMobile ? { y: '100%' } : { x: '100%' }}
          transition={{
            type: 'spring',
            damping: 30,
            stiffness: 300,
          }}
          className={clsx(
            'fixed bg-white shadow-2xl z-50 flex flex-col',
            isMobile ? 'inset-0' : 'top-0 right-0 bottom-0 w-[400px]',
          )}
        >
          {/* Header */}
          <div className="flex items-center justify-between gap-3 px-4 py-3 bg-white border-b border-gray-200">
            <Button
              id="help-drawer-close"
              variant="click-wrapper"
              onClick={closeHelpDrawer}
              className="flex-shrink-0 text-sm font-medium text-purple-600 transition-colors hover:text-purple-700 w-9"
              aria-label="Close help drawer"
            >
              Done
            </Button>
            {title && (
              <div className="flex-1 text-sm text-center text-gray-900 truncate">
                {title}
              </div>
            )}
            <Button
              id="help-drawer-refresh"
              variant="icon"
              onClick={handleRefresh}
              className="flex-shrink-0"
              aria-label="Refresh help content"
            >
              <Icon name="RotateCw" size={20} className="text-purple-600" />
            </Button>
          </div>

          {/* iframe Content */}
          <div className="flex-1 overflow-hidden">
            <iframe
              key={iframeKey}
              src={url}
              className="w-full h-full border-0"
              title="Help Documentation"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
